import { defineNuxtPlugin } from '#app/nuxt'
import { LazyWorkflowNotifications, LazyDjBanner, LazyDjBreadCrumb, LazyDjGhostBtn, LazyDjImage, LazyDjImageZoom, LazyDjPagination, LazyAuthLoginBackdrop, LazyCartDisplay, LazyAddressModal, LazyCheckoutOverlay, LazyCompactAddressStep, LazyCompactConfirmationStep, LazyCompactPaymentStep, LazyInlineCheckout, LazyOrderSummary, LazyDataContainer, LazyTableShoppingCart, LazyChatHeader, LazyChatInput, LazyChatN8N, LazyTypingIndicator, LazyAddToCartCard, LazyChatMessage, LazyChatMessages, LazyOrderCard, LazyProductCard, LazyMonthlyAnalysisContent, LazyMonthlyAnalysisWrapper, LazyOrderDetailContent, LazyOrderDetailWrapper, LazyOrderProductTable, LazyHelpers, LazyMessageFormatter, LazyAuthLayout, LazyBlankLayout, LazyDefaultLayout, LazyDjAddProductForm, LazyDjAddToBuyingListButton, LazyDjAddToCartButton, LazyDjAddToQuoteButton, LazyDjAddressSelect, LazyDjAddresses, LazyDjCarousel, LazyDjCategoryCollapsible, LazyDjCollapsibleMenu, LazyDjComment, LazyDjComments, LazyDjContactProfile, LazyDjCurrencySwitcher, LazyDjFaq, LazyDjFeatureItem, LazyDjFilteredLinkItem, LazyDjFooterBottom, LazyDjHeaderBottom, LazyDjHeaderMain, LazyDjIconWithText, LazyDjInlineSearchBar, LazyDjLangSwitcher, LazyDjMessages, LazyDjNoStockBlock, LazyDjOrderActions, LazyDjOrderLineItem, LazyDjOrderLinesTable, LazyDjOrderListItem, LazyDjProductCartCard, LazyDjProductDescriptionSection, LazyDjProductFeaturesSection, LazyDjProductQuoteCard, LazyDjProductSearchResult, LazyDjProductSearchResultVariant, LazyDjProductSearchResultv3, LazyDjProductTitleSection, LazyDjProductVariantInfo, LazyDjQuantity, LazyDjReassuranceList, LazyDjRecommendationCard, LazyDjRecommendationsBlock, LazyDjReportIncident, LazyDjSearchBar, LazyDjSlideItem, LazyDjSplitHeroSection, LazyDjStep, LazyDjSteps, LazyDjTabs, LazyDjAccountLayout, LazyDjBuyingListItem, LazyDjCartActions, LazyDjCartLineTable, LazyDjCartMiniProducts, LazyDjCartProducts, LazyDjCartSummary, LazyDjContactReference, LazyDjFilteredLinkSlider, LazyDjFooter, LazyDjHeader, LazyDjOrderProducts, LazyDjOrderRecap, LazyDjOrderSummary, LazyDjProductActionsSection, LazyDjProductCardHorizontal, LazyDjProductCardVertical, LazyDjProductImageGallery, LazyDjProductInfo, LazyDjProductPrice, LazyDjProductVariantsTable, LazyDjProductsList, LazyDjQuoteDetail, LazyDjQuoteLineTable, LazyDjRelatedProductCardVertical, LazyDjShippingActions, LazyDjWorkflow, LazyDjAddressesPage, LazyDjBuyingListPage, LazyDjContactUsPage, LazyDjCustomerAccountPage, LazyDjOrdersPage, LazyDjProfilePage, LazyDjQuoteOrderConfirmationPage, LazyDjQuotesPage, LazyDjPageForgetPassword, LazyDjPageGetAccess, LazyDjPageLogin, LazyDjPageResetPassword, LazyDjCartPage, LazyDjChatPage, LazyDjCollectionCategoryPage, LazyDjCollectionPage, LazyDjFastCartPage, LazyDjHomePage, LazyDjOrderConfirmationPage, LazyDjOrderPage, LazyDjProductPage, LazyDjServicesPage, LazyDjShippingPage, LazyCartButton, LazyDjUpload, LazyEmailTable, LazyEmptyState, LazyProductFilters, LazyProductRecommendations, LazyProductTableHeader, LazyDjBrandsList, LazyDjCartLayer, LazyDjCheckoutAddressSection, LazyDjCheckoutCustomSection, LazyDjHeroSection, LazyDjHpSlider, LazyDjOrderInfo, LazyDjRelatedProducts, LazyDjEmailTableRow, LazyProductItem, LazyProductStatus, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["WorkflowNotifications", LazyWorkflowNotifications],
["DjBanner", LazyDjBanner],
["DjBreadCrumb", LazyDjBreadCrumb],
["DjGhostBtn", LazyDjGhostBtn],
["DjImage", LazyDjImage],
["DjImageZoom", LazyDjImageZoom],
["DjPagination", LazyDjPagination],
["AuthLoginBackdrop", LazyAuthLoginBackdrop],
["CartDisplay", LazyCartDisplay],
["AddressModal", LazyAddressModal],
["CheckoutOverlay", LazyCheckoutOverlay],
["CompactAddressStep", LazyCompactAddressStep],
["CompactConfirmationStep", LazyCompactConfirmationStep],
["CompactPaymentStep", LazyCompactPaymentStep],
["InlineCheckout", LazyInlineCheckout],
["OrderSummary", LazyOrderSummary],
["DataContainer", LazyDataContainer],
["TableShoppingCart", LazyTableShoppingCart],
["ChatHeader", LazyChatHeader],
["ChatInput", LazyChatInput],
["ChatN8N", LazyChatN8N],
["TypingIndicator", LazyTypingIndicator],
["AddToCartCard", LazyAddToCartCard],
["ChatMessage", LazyChatMessage],
["ChatMessages", LazyChatMessages],
["OrderCard", LazyOrderCard],
["ProductCard", LazyProductCard],
["MonthlyAnalysisContent", LazyMonthlyAnalysisContent],
["MonthlyAnalysisWrapper", LazyMonthlyAnalysisWrapper],
["OrderDetailContent", LazyOrderDetailContent],
["OrderDetailWrapper", LazyOrderDetailWrapper],
["OrderProductTable", LazyOrderProductTable],
["Helpers", LazyHelpers],
["MessageFormatter", LazyMessageFormatter],
["AuthLayout", LazyAuthLayout],
["BlankLayout", LazyBlankLayout],
["DefaultLayout", LazyDefaultLayout],
["DjAddProductForm", LazyDjAddProductForm],
["DjAddToBuyingListButton", LazyDjAddToBuyingListButton],
["DjAddToCartButton", LazyDjAddToCartButton],
["DjAddToQuoteButton", LazyDjAddToQuoteButton],
["DjAddressSelect", LazyDjAddressSelect],
["DjAddresses", LazyDjAddresses],
["DjCarousel", LazyDjCarousel],
["DjCategoryCollapsible", LazyDjCategoryCollapsible],
["DjCollapsibleMenu", LazyDjCollapsibleMenu],
["DjComment", LazyDjComment],
["DjComments", LazyDjComments],
["DjContactProfile", LazyDjContactProfile],
["DjCurrencySwitcher", LazyDjCurrencySwitcher],
["DjFaq", LazyDjFaq],
["DjFeatureItem", LazyDjFeatureItem],
["DjFilteredLinkItem", LazyDjFilteredLinkItem],
["DjFooterBottom", LazyDjFooterBottom],
["DjHeaderBottom", LazyDjHeaderBottom],
["DjHeaderMain", LazyDjHeaderMain],
["DjIconWithText", LazyDjIconWithText],
["DjInlineSearchBar", LazyDjInlineSearchBar],
["DjLangSwitcher", LazyDjLangSwitcher],
["DjMessages", LazyDjMessages],
["DjNoStockBlock", LazyDjNoStockBlock],
["DjOrderActions", LazyDjOrderActions],
["DjOrderLineItem", LazyDjOrderLineItem],
["DjOrderLinesTable", LazyDjOrderLinesTable],
["DjOrderListItem", LazyDjOrderListItem],
["DjProductCartCard", LazyDjProductCartCard],
["DjProductDescriptionSection", LazyDjProductDescriptionSection],
["DjProductFeaturesSection", LazyDjProductFeaturesSection],
["DjProductQuoteCard", LazyDjProductQuoteCard],
["DjProductSearchResult", LazyDjProductSearchResult],
["DjProductSearchResultVariant", LazyDjProductSearchResultVariant],
["DjProductSearchResultv3", LazyDjProductSearchResultv3],
["DjProductTitleSection", LazyDjProductTitleSection],
["DjProductVariantInfo", LazyDjProductVariantInfo],
["DjQuantity", LazyDjQuantity],
["DjReassuranceList", LazyDjReassuranceList],
["DjRecommendationCard", LazyDjRecommendationCard],
["DjRecommendationsBlock", LazyDjRecommendationsBlock],
["DjReportIncident", LazyDjReportIncident],
["DjSearchBar", LazyDjSearchBar],
["DjSlideItem", LazyDjSlideItem],
["DjSplitHeroSection", LazyDjSplitHeroSection],
["DjStep", LazyDjStep],
["DjSteps", LazyDjSteps],
["DjTabs", LazyDjTabs],
["DjAccountLayout", LazyDjAccountLayout],
["DjBuyingListItem", LazyDjBuyingListItem],
["DjCartActions", LazyDjCartActions],
["DjCartLineTable", LazyDjCartLineTable],
["DjCartMiniProducts", LazyDjCartMiniProducts],
["DjCartProducts", LazyDjCartProducts],
["DjCartSummary", LazyDjCartSummary],
["DjContactReference", LazyDjContactReference],
["DjFilteredLinkSlider", LazyDjFilteredLinkSlider],
["DjFooter", LazyDjFooter],
["DjHeader", LazyDjHeader],
["DjOrderProducts", LazyDjOrderProducts],
["DjOrderRecap", LazyDjOrderRecap],
["DjOrderSummary", LazyDjOrderSummary],
["DjProductActionsSection", LazyDjProductActionsSection],
["DjProductCardHorizontal", LazyDjProductCardHorizontal],
["DjProductCardVertical", LazyDjProductCardVertical],
["DjProductImageGallery", LazyDjProductImageGallery],
["DjProductInfo", LazyDjProductInfo],
["DjProductPrice", LazyDjProductPrice],
["DjProductVariantsTable", LazyDjProductVariantsTable],
["DjProductsList", LazyDjProductsList],
["DjQuoteDetail", LazyDjQuoteDetail],
["DjQuoteLineTable", LazyDjQuoteLineTable],
["DjRelatedProductCardVertical", LazyDjRelatedProductCardVertical],
["DjShippingActions", LazyDjShippingActions],
["DjWorkflow", LazyDjWorkflow],
["DjAddressesPage", LazyDjAddressesPage],
["DjBuyingListPage", LazyDjBuyingListPage],
["DjContactUsPage", LazyDjContactUsPage],
["DjCustomerAccountPage", LazyDjCustomerAccountPage],
["DjOrdersPage", LazyDjOrdersPage],
["DjProfilePage", LazyDjProfilePage],
["DjQuoteOrderConfirmationPage", LazyDjQuoteOrderConfirmationPage],
["DjQuotesPage", LazyDjQuotesPage],
["DjPageForgetPassword", LazyDjPageForgetPassword],
["DjPageGetAccess", LazyDjPageGetAccess],
["DjPageLogin", LazyDjPageLogin],
["DjPageResetPassword", LazyDjPageResetPassword],
["DjCartPage", LazyDjCartPage],
["DjChatPage", LazyDjChatPage],
["DjCollectionCategoryPage", LazyDjCollectionCategoryPage],
["DjCollectionPage", LazyDjCollectionPage],
["DjFastCartPage", LazyDjFastCartPage],
["DjHomePage", LazyDjHomePage],
["DjOrderConfirmationPage", LazyDjOrderConfirmationPage],
["DjOrderPage", LazyDjOrderPage],
["DjProductPage", LazyDjProductPage],
["DjServicesPage", LazyDjServicesPage],
["DjShippingPage", LazyDjShippingPage],
["CartButton", LazyCartButton],
["DjUpload", LazyDjUpload],
["EmailTable", LazyEmailTable],
["EmptyState", LazyEmptyState],
["ProductFilters", LazyProductFilters],
["ProductRecommendations", LazyProductRecommendations],
["ProductTableHeader", LazyProductTableHeader],
["DjBrandsList", LazyDjBrandsList],
["DjCartLayer", LazyDjCartLayer],
["DjCheckoutAddressSection", LazyDjCheckoutAddressSection],
["DjCheckoutCustomSection", LazyDjCheckoutCustomSection],
["DjHeroSection", LazyDjHeroSection],
["DjHpSlider", LazyDjHpSlider],
["DjOrderInfo", LazyDjOrderInfo],
["DjRelatedProducts", LazyDjRelatedProducts],
["DjEmailTableRow", LazyDjEmailTableRow],
["ProductItem", LazyProductItem],
["ProductStatus", LazyProductStatus],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
